"use client";

import { CcDemoTabs } from "@/components/services/shared/CcDemoTabs";
import { CcSanjayaEyebrow } from "@/components/ui/CcSanjayaEyebrow";
import { devSectionAttr } from "@/lib/dev/section-attr";

import type { AdvertisingDemoCopy } from "./advertising-demo-copy";
import {
  AdGrowthPhotoView,
  AdTestsPhotoView,
  AdTrackingPhotoView,
} from "./CcAdValuePhotoViews";

type CcAdValueProps = {
  copy: AdvertisingDemoCopy;
};

/**
 * "Värdet av rätt annonsering": three tabs following one made-up online shop
 * (every krona tracked → more messages tested → profitable growth) as
 * real photos with cards and the real channels' logos.
 */
export function CcAdValue({ copy }: CcAdValueProps) {
  return (
    <section
      className="cc-section cc-seo-value"
      aria-labelledby="cc-ad-value-title"
      data-cc-nav="light"
      {...devSectionAttr("ad-value")}
    >
      <div className="cc-container">
        <header className="cc-seo-value__header">
          <CcSanjayaEyebrow theme="on-subtle">{copy.eyebrow}</CcSanjayaEyebrow>
          <h2 id="cc-ad-value-title" className="cc-seo-heading">
            {copy.title}
          </h2>
          <p className="cc-seo-lead cc-seo-value__lead">{copy.lead}</p>
        </header>

        <CcDemoTabs
          tablistLabel={copy.tablistLabel}
          disclaimer={copy.disclaimer}
          tabs={[
            {
              key: "tracking",
              label: copy.tabs.tracking,
              summary: copy.tracking.summary,
              content: <AdTrackingPhotoView copy={copy.tracking} />,
            },
            {
              key: "tests",
              label: copy.tabs.tests,
              summary: copy.tests.summary,
              content: <AdTestsPhotoView copy={copy.tests} />,
            },
            {
              key: "growth",
              label: copy.tabs.growth,
              summary: copy.growth.summary,
              content: <AdGrowthPhotoView copy={copy.growth} />,
            },
          ]}
        />

        <p className="cc-seo-value__footnote">{copy.footnote}</p>
      </div>
    </section>
  );
}
